import { css } from 'styled-components';

export const filterButtonStyles = css`
  width: 48px;
  height: 48px;
  padding: 10px;
`;
